'use strict';

var React = require('react');
var text = require('../../../helpers/text.js');
var keyboard = require('../../../helpers/keyboard.js');
var index = require('../../Flex/index.js');
var component$1 = require('../../Text/component.js');
var component = require('../Radio/component.js');
var styles = require('./styles.js');
var context = require('./context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const SelectOption = React.forwardRef(({ value, label, isPlaceholder, className, ...props }, ref) => {
    const { value: selectedValue, formatLabel, onChange, variant } = context.useSelectContext();
    const labelFromValue = formatLabel(value);
    const labelFromSelectedValue = formatLabel(selectedValue);
    const hasValue = value !== undefined;
    const isSelected = hasValue && labelFromValue === labelFromSelectedValue;
    const onClick = (event) => {
        if (isPlaceholder) {
            return event.preventDefault();
        }
        return onChange(value);
    };
    const onKeyDown = (event) => {
        if (keyboard.isKey('space', 'enter')(event)) {
            event.preventDefault();
            onChange(value);
        }
    };
    return (React__default.default.createElement(styles.Styled.DropdownOption, { ...props, className: text.classNames(isSelected && 'focus', className), ref: ref, role: "option", "aria-selected": isSelected, onKeyDown: onKeyDown, onClick: onClick, onFocus: e => e.stopPropagation(), isPlaceholder: isPlaceholder },
        React__default.default.createElement(index.Flex.Row, { space: "s" },
            variant === 'radio' && (React__default.default.createElement(styles.Styled.RadioContainer, null,
                React__default.default.createElement(component.Radio, { checked: isSelected }))),
            React__default.default.createElement(component$1.Text, { variant: "body-lighter" }, label ?? labelFromValue))));
});
SelectOption.displayName = 'Select.Option';

exports.SelectOption = SelectOption;
//# sourceMappingURL=Option.js.map
